import { render, staticRenderFns } from "./IndexFloor.vue?vue&type=template&id=6deb445a&scoped=true"
import script from "./IndexFloor.vue?vue&type=script&lang=js"
export * from "./IndexFloor.vue?vue&type=script&lang=js"
import style0 from "./IndexFloor.vue?vue&type=style&index=0&id=6deb445a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb445a",
  null
  
)

export default component.exports